<div class="module module-video">
    <div class="module-content">
        <span class="animated delay-1 fadeIn">{{data.titulo}}</span>
    </div>
    <video class="lazy" #video loop autoplay control>
        <source title="videos/modulo/{{data.params.video}}" type="video/mp4" /> 
    </video>
</div>  
  